module.exports = __webpack_public_path__ + "dcef80c.ttf";